export default __webpack_public_path__ + "static/media/arrow--left.57ffec28.svg";